import { takeLatest, put, call } from 'redux-saga/effects';
import { CORE_API } from '../../../../config';
import request from '../../../../components/Utils/httpHelper';
import { HTTP_HEADERS } from '../../../../constants';

import {
    responseOfUnprocessedNewsData,
    REQUEST_FOR_UNPROCESSED_DATA_FOR_NEWS_MODERATION,
    POST_PROCESSED_NEWS_DATA_TO_SERVER,
    responseOfpostProcessedNewsDataToServer
} from './action';
import { func } from 'prop-types';

export function* fetchUnprocessedNewsData(action) {
    let requestURL = `${CORE_API}/news/api/news-unprocessed-data/${action.data}`;
     try {
        const result = yield call(request, requestURL, { method: 'GET',  headers: HTTP_HEADERS } );
        yield put(responseOfUnprocessedNewsData({data : result.data, status : result.status}));
    } catch (err) {
        yield put(responseOfUnprocessedNewsData({...err.response.data, status  : err.response.status}))
    } 
}

export function* fetchUnprocessedNewsDataFromServer() {
    yield takeLatest(REQUEST_FOR_UNPROCESSED_DATA_FOR_NEWS_MODERATION, fetchUnprocessedNewsData);
}

export function* postProcessedNewsData(action) {
    let requestURL = `${CORE_API}/news/api/news-processed-data`;
     try {
        const result = yield call(request, requestURL, { method: 'POST', data : action.data.data,  headers: HTTP_HEADERS } );
        yield put(responseOfpostProcessedNewsDataToServer({ response : result.data, status : result.status}));
    } catch (err) {
        yield put(responseOfpostProcessedNewsDataToServer({ ...err.response.data, status  : err.response.status}))
    } 
}

export function* postProcessedNewsDataToServer(){
    yield takeLatest(POST_PROCESSED_NEWS_DATA_TO_SERVER, postProcessedNewsData);
}